module.exports = __webpack_public_path__ + "static/media/rebirth_17.04c1f226.jpg";